import React from "react";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { Globe, User } from "lucide-react";
import { toast } from "sonner";

export default function Settings() {
  const { t, lang, setLang } = useI18n();
  const { user, refresh, signOut } = useAuth();

  const updateLocale = async (newLang) => {
    setLang(newLang);
    try {
      await api.patch("/auth/me", { locale: newLang });
      await refresh();
      toast.success(newLang === "fr" ? "Préférences enregistrées" : "Preferences saved");
    } catch {
      // ignore
    }
  };

  return (
    <div className="App min-h-screen bg-background">
      <Header variant="app" />
      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="font-mono text-xs uppercase tracking-wider text-[#002FA7]">// Settings</div>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tight sm:text-4xl">{t("settings.title")}</h1>

        <section className="mt-8 border border-border bg-card">
          <div className="border-b border-border px-5 py-3 font-mono text-xs uppercase text-muted-foreground flex items-center gap-2">
            <Globe className="h-3.5 w-3.5" /> {t("settings.language")}
          </div>
          <div className="grid grid-cols-2 gap-2 p-5">
            <button
              onClick={() => updateLocale("fr")}
              className={`border p-4 text-left transition ${lang === "fr" ? "border-[#002FA7] bg-[#002FA7]/5" : "border-border hover:border-foreground/30"}`}
              data-testid="lang-fr-button"
            >
              <div className="font-mono text-xs text-muted-foreground">FR</div>
              <div className="font-display text-lg font-bold">{t("settings.french")}</div>
            </button>
            <button
              onClick={() => updateLocale("en")}
              className={`border p-4 text-left transition ${lang === "en" ? "border-[#002FA7] bg-[#002FA7]/5" : "border-border hover:border-foreground/30"}`}
              data-testid="lang-en-button"
            >
              <div className="font-mono text-xs text-muted-foreground">EN</div>
              <div className="font-display text-lg font-bold">{t("settings.english")}</div>
            </button>
          </div>
        </section>

        <section className="mt-6 border border-border bg-card">
          <div className="border-b border-border px-5 py-3 font-mono text-xs uppercase text-muted-foreground flex items-center gap-2">
            <User className="h-3.5 w-3.5" /> {t("settings.account")}
          </div>
          <div className="flex flex-wrap items-center justify-between gap-3 p-5">
            <div className="min-w-0">
              <div className="font-display font-bold truncate">{user?.name || user?.email}</div>
              <div className="font-mono text-xs text-muted-foreground truncate">{user?.email}</div>
            </div>
            <Button onClick={signOut} variant="outline" className="rounded-sm" data-testid="settings-signout">
              {t("nav.logout")}
            </Button>
          </div>
        </section>
      </main>
    </div>
  );
}
